import { render, staticRenderFns } from "./new-revert.vue?vue&type=template&id=aebca52c&functional=true"
import script from "./new-revert.vue?vue&type=script&lang=js"
export * from "./new-revert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports